export default "__VITE_ASSET__B5YBj5Xs__"